if (!customElements.get('accordion-disclosure')) {
  customElements.define('accordion-disclosure', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.details = this.querySelector('.accordion__details');
      this.summary = this.querySelector('.accordion__summary');
      this.body = this.querySelector('.accordion__body');
      this.animation?.cancel();
      if (!this.details || !this.summary || !this.body) return;

      this.summary.addEventListener('click', event => {
        event.preventDefault();
        this.details.open ? this.close() : this.open();
      }, { signal });

      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !this.details.open) return;
        event.preventDefault();
        this.close(true);
      }, { signal });

      document.addEventListener('shopify:block:select', event => {
        if (this.contains(event.target) && !this.details.open) this.open();
      }, { signal });
    }

    get reducedMotion() { return matchMedia('(prefers-reduced-motion: reduce)').matches; }

    open() {
      this.closeGroupSiblings();
      this.animation?.cancel();
      this.details.open = true;
      if (this.reducedMotion) return;
      const height = this.body.scrollHeight;
      this.animation = this.body.animate([
        { height: '0px', opacity: 0, transform: 'translateY(-3px)' },
        { height: `${height}px`, opacity: 1, transform: 'translateY(0)' }
      ], { duration: 210, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'both' });
      this.animation.finished.then(() => this.animation?.cancel()).catch(() => {});
    }

    close(restoreFocus = false) {
      if (!this.details.open) return;
      this.animation?.cancel();
      if (this.reducedMotion) {
        this.details.open = false;
        if (restoreFocus) this.summary.focus();
        return;
      }
      const height = this.body.getBoundingClientRect().height;
      this.animation = this.body.animate([
        { height: `${height}px`, opacity: 1, transform: 'translateY(0)' },
        { height: '0px', opacity: 0, transform: 'translateY(-2px)' }
      ], { duration: 145, easing: 'cubic-bezier(.4, 0, 1, 1)', fill: 'both' });
      this.animation.finished.then(() => {
        this.details.open = false;
        this.animation?.cancel();
        if (restoreFocus) this.summary.focus();
      }).catch(() => {});
    }

    closeGroupSiblings() {
      const group = this.dataset.group;
      if (!group) return;
      document.querySelectorAll('accordion-disclosure').forEach(disclosure => {
        if (disclosure !== this && disclosure.dataset.group === group) disclosure.close();
      });
    }

    disconnectedCallback() {
      this.animation?.cancel();
      this.abortController?.abort();
    }
  });
}
